"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureFlag = useFeatureFlag;
var _react = require("react");
var _ = require("./");
function useFeatureFlag(flagName) {
  var featureFlags = (0, _react.useContext)(_.FeatureFlagContext);
  return featureFlags[flagName] || false;
}